import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Box, Button, Chip, Grid, MenuItem, Modal, Select, TextField, ThemeProvider, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import passengerApi from "../../api/passengerApi";
import { ContextUserInfo } from "../../Layout/MainLayout";
import customtheme from '../../themes';
import { useSelector } from 'react-redux';
import PassengerInfo from "./passengerInfo";
import { RHFAutocomplete } from "../../Components/RHFAutocomplete";
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import CustomDateInput from "../../Components/CustomDateInput";
import gregorian from "react-date-object/calendars/gregorian"
import gregorian_en from "react-date-object/locales/gregorian_en"
import DateObject from "react-date-object";
import RtlProvider from "../../Components/RtlProvider"
import helper from "../../helper";

import Excel from 'exceljs';
import { saveAs } from 'file-saver';
import { CircularProgress, IconButton, Tooltip } from '@mui/material';
import { ImFileExcel } from "react-icons/im";
import AccessControl from "../../Components/AccessControl";
import EnumMapper from "../../EnumMapper";
import moment from 'jalali-moment'
import { MdPlusOne } from "react-icons/md";
import { FaPlus } from "react-icons/fa";
import TagsInput from "react-tagsinput";
import './../../Styles/react-tagsinput.css'
import brokerGroupApi from "../../api/brokerGroupApi";
import staticData from "../../data/StaticData";

const filterOperatorNumber = [
  {
    id: 0,
    label: "----"
  },
  {
    id: 1,
    label: "برابر با"
  },
  {
    id: 2,
    label: "به جز"
  },
  {
    id: 3,
    label: "بزرگتر"
  },
  {
    id: 4,
    label: "بزرگتر یا مساوی"
  },
  {
    id: 5,
    label: "کوچکتر"
  },
  {
    id: 6,
    label: "کوچکتر یا مساوی"
  },
  {
    id: 7,
    label: "شامل"
  },
]
const filterOperatorTxt = [
  {
    id: 0,
    label: "----"
  },
  {
    id: 1,
    label: "برابر با"
  },
  {
    id: 2,
    label: "به جز"
  },
  {
    id: 7,
    label: "شامل"
  },
]
const filterOperatorType = [
  {
    id: 0,
    label: "----"
  },
  {
    id: 1,
    label: "برابر با"
  },
  {
    id: 2,
    label: "به جز"
  },

]
const sexType = [
  {
    id: null,
    label: "----"
  },
  {
    id: "male",
    label: "مرد"
  },
  {
    id: "female",
    label: "زن"
  }
]
const passengerType = [
  {
    id: 0,
    label: "همه"
  },
  {
    id: 1,
    label: "زائر"
  },
  {
    id: 2,
    label: "غیر زائر"
  }
]


const SearchPassenger = () => {
  const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
  const [brokerIDS, setBrokerIDS] = useState([]);
  const [groupNoS, setGroupNoS] = useState([]);
  const [data, setData] = useState([]);
  const [loadingExport, SetLoadingExport] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const[opration,setOpration]=useState([]);


  //table state
  const [columnFilters, setColumnFilters] = useState(
    [],
  );
  const [globalFilter, setGlobalFilter] = useState('');
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });

  const customization = useSelector((state) => state.customization);
  const [openPassengerModal, setOpenPassengerModal] = useState(false);
  const [openPassengerModalMali, setOpenPassengerModalMali] = useState(false);
  const [selectedPassenger, setSelectedPassenger] = React.useState(null);
  const [SSNList, setSSNList] = useState([])

  const handleOpenPassengerModal = (e) => {

    setOpenPassengerModal(true);
    setSelectedPassenger(e)
  };
  const handleClosePassengerModal = () => {
    setSelectedPassenger(null)
    setOpenPassengerModal(false);
  };
  const handleOpenPassengerModalMali = (e) => {

    setOpenPassengerModalMali(true);
    setSelectedPassenger(e)
  };
  const handleClosePassengerModalMali = () => {
    setSelectedPassenger(null)
    setOpenPassengerModalMali(false);
  };

  const schema = yup.object().shape({

  });
  const { register, setValue, handleSubmit, formState: { errors }, control, resetField, reset, getValues, watch } = useForm({
    defaultValues: {
     oprationId:"1",
      SSNFO: 1,
      ssn: null,
      passengerType: 0,
      nameFO: 7,
      name: null,
      familyFO: 7,
      lastName: null,
      fatherNameFO:7,
      fatherName:null,
      ageGroupFO: 1,
      passNoFO: 1,
      passNo: null,
      brokerID: null,
      groupNo: null,
      flightNO: null,
      sexTypeID: null,
      orderType: "Name",
      order: 0

    },
    resolver: yupResolver(schema),
  });
  //export to excel
  const workSheetName = 'Sheet1';
  const workbook = new Excel.Workbook();

  const getfilteritems = () => {
    const filterItems = [];
    // const ssnArr = [];
    // watch("ssn") && ssnArr.push(watch("ssn"))


    watch("name") && filterItems.push({
      "propertyName": "name",
      "operator": watch("nameFO") ? watch("nameFO") - 1 : 0,
      "value": helper.convertArabicToPersian(watch("name"))

    })

    watch("lastName") && filterItems.push({
      "propertyName": "family",
      "operator": watch("familyFO") ? watch("familyFO") - 1 : 0,
      "value": helper.convertArabicToPersian(watch("lastName"))

    })
    watch("fatherName") && filterItems.push({
      "propertyName": "fatherName",
      "operator": watch("fatherNameFO") ? watch("fatherNameFO") - 1 : 0,
      "value": helper.convertArabicToPersian(watch("fatherName"))

    })
    watch("ageGroupFO") && watch("ageGroupID") && filterItems.push({
      "propertyName": "AgeTypeArabianID",
      "operator": watch("ageGroupFO") - 1,
      "value": watch("ageGroupID")

    })

    watch("passNo") && filterItems.push({
      "propertyName": "passNo",
      "operator": watch("passNoFO") ? watch("passNoFO") - 1 : 0,
      "value": watch("passNo")

    })

    watch("brokerID") && filterItems.push({
      "propertyName": "PassengerGroup.Broker.ID",
      "operator": 0,
      "value": watch("brokerID")

    })
    watch("groupNo") && filterItems.push({
      "propertyName": "PassengerGroup.GroupNO",
      "operator": 0,
      "value": watch("groupNo")

    })
    // watch("flightNo") && filterItems.push({
    //   "propertyName": "flightNo",
    //   "operator": 6,
    //   "value": watch("flightNo")

    // })

    watch("sexTypeID") && filterItems.push({
      "propertyName": "sexType",
      "operator": 0,
      "value": watch("sexTypeID")

    })

    let passengerType = null;
    if (watch("passengerTypeID")) {
      passengerType = watch("passengerTypeID");
      if (parseInt(passengerType) === parseInt(EnumMapper.PassengerType.Zaer))
        filterItems.push({
          "propertyName": "passengerType",
          "operator": 0,
          "value": "1"
        })
      else if (parseInt(passengerType) === parseInt(EnumMapper.PassengerType.NoZaer))
        filterItems.push({
          "propertyName": "passengerType",
          "operator": 1,
          "value": "1"
        })
    }

    let flightDateFromGregorian = null;
    if (watch("flightDateFrom")) {
      let flightDate = new DateObject({
        date: watch("flightDateFrom"),
        calendar: persian,
        locale: persian_fa
      });
      // flightDateFromGregorian = flightDate.convert(gregorian, gregorian_en).format("YYYY-MM-DD");
      var flightDateFromStr = flightDate.year + '/' + flightDate.month.number + '/' + flightDate.day;
      flightDateFromGregorian = moment.from(flightDateFromStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
    }
    // flightDateFromGregorian && filterItems.push({
    //   "propertyName": "flightDate",
    //   "operator": 3,
    //   "value": flightDateFromGregorian

    // })
    let flightDateToGregorian = null;
    if (watch("flightDateTo")) {
      let flightDate = new DateObject({
        date: watch("flightDateTo"),
        calendar: persian,
        locale: persian_fa
      });
      // flightDateToGregorian = flightDate.convert(gregorian, gregorian_en).format("YYYY-MM-DD");
      var flightDateToStr = flightDate.year + '/' + flightDate.month.number + '/' + flightDate.day;
      flightDateToGregorian = moment.from(flightDateToStr, 'fa', 'YYYY/MM/DD').format('YYYY-MM-DD')
    }
    // flightDateToGregorian && filterItems.push({
    //   "propertyName": "flightDate",
    //   "operator": 5,
    //   "value": flightDateToGregorian

    // })
     const flightNO = watch("flightNO");
var opetationId=watch("oprationId")? parseInt(watch("oprationId")):1;
    const paginationData = {
      
      "inputDto": {
        "filters": filterItems,
        "orderBy": sorting.length > 0 ? sorting[0].id : 'PassengerGroup.CreateOn',
        "orderDescending": sorting.length > 0 ? sorting[0].desc : true,

        "pageSize": pagination.pageSize,
        "pageNumber": pagination.pageIndex + 1,
      },
      "optionalParams": {
        "from": flightDateFromGregorian,
        "to": flightDateToGregorian,
        "nationalCode": SSNList.length > 0 ? SSNList : null,
        "flightNO":flightNO,
         "opration":opetationId,
      }
    }
    return paginationData;
  }


  const onSubmit = () => {

    const paginationModel = getfilteritems();

    GetData(paginationModel);
    // setTimeout(() => {
    //   GetExportData(paginationModel); 
    // }, (1000));


  };
  useEffect(() => {
     fillOprationDropDown();
    GetBrokers();
  }, []);
  useEffect(() => {

    const paginationModel = getfilteritems();
    GetData(paginationModel);

  }, [
    columnFilters, //re-fetch when column filters change
    globalFilter, //re-fetch when global filter changes
    pagination.pageIndex, //re-fetch when page index changes
    pagination.pageSize, //re-fetch when page size changes
    sorting, //re-fetch when sorting changes

  ]);

  const fillOprationDropDown=()=>{
  brokerGroupApi.GetOprationDropDown().then((res) => {
    const arr = helper.DictionayToList(res.data.data);
        setOpration(arr.map((o) => {
          return {
            id: o.key,
            label: o.value
          };
        }));
        })
        .catch((error1) => {
          console.log(error1);
          setIsError(true);
        })
       
    }
  
  const GetBrokers = () => {
    passengerApi.GetBrokers().then((res) => {

      const arr = helper.DictionayToList(res.data.data);
      setBrokerIDS(arr.map((o) => {
        return {
          id: o.key,
          label: o.value
        };
      }));
    }
    )
      .catch((error) => {
        console.log(error);
      })
  }
  const GetExportData = (paginationData, totalcount, type) => {
    var clmns = [];
    var filename = '';
    if (type === 1) {
      filename = 'لیست زائران عمره'
      clmns = [{ header: 'نام', key: 'name' },
      { header: 'نام خانوادگی', key: 'family' },
      { header: 'کدملی', key: 'ssn' },
      { header: 'شماره گذر', key: 'passNO' },
      { header: 'تاریخ پرواز', key: 'flightDate' },
      { header: 'نام پدر', key: 'fatherName' },
      { header: 'شماره کاروان', key: 'brokerNo' },
      { header: 'شماره گروه', key: 'groupNo' },
      { header: 'گروه سنی', key: 'ageTypeTitle' },
      { header: 'نوع', key: 'passengerTypeTitle' },
      ]
    }
    else if (type === 2) {
      filename = ' لیست زائران عمره با اطلاعات مالی'
      clmns = [{ header: 'نام', key: 'name' },
      { header: 'نام خانوادگی', key: 'family' },
      { header: 'کدملی', key: 'ssn' },
      { header: 'شماره گذر', key: 'passNO' },
      { header: ' نام کارگزار', key: 'brokerName' },
      { header: 'شماره کاروان', key: 'brokerNo' },
      { header: 'شماره گروه', key: 'groupNo' },
      { header: 'تاریخ پرواز ', key: 'flightDate' },
      { header: 'شماره شبا', key: 'shebaAccount' },
      { header: 'گروه قیمتی', key: 'priceGroupTitle' },
      { header: 'گروه سنی', key: 'ageTypeTitle' },
      { header: 'نوع', key: 'passengerTypeTitle' },
    ]
    }
    paginationData.inputDto.pageNumber = 1;
    paginationData.inputDto.pageSize = totalcount;
    SetLoadingExport(true);
    passengerApi.CustomFilter(paginationData)
      .then((outdata) => {

        const ExpData = outdata.data.items.map((rw) => { return rw.data })
        saveExcel(ExpData, clmns, filename);

      })
      .catch((error1) => {
        console.log(error1);
        setIsError(true);
      })
      .finally(() => {
        SetLoadingExport(false);
      })

  }
  const GetData = (paginationData) => {
    if (!data.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    passengerApi.CustomFilter(paginationData)
      .then((data) => {
        setData(data.data.items);
        const rowcnt = data.data.totalCount;
        setRowCount(rowcnt);

      })
      .catch((error) => {
        console.log(error);
        setIsError(true);
      }).finally(() => {
        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
      });
  };

  const handleExportClick = async (type) => {

    const paginationModel = getfilteritems();
    if (!data.length) {
      setIsLoading(true);
    } else {
      setIsRefetching(true);
    }
    passengerApi.CustomFilter(paginationModel)
      .then((data) => {
        setData(data.data.items);
        const rowcnt = data.data.totalCount;
        setRowCount(rowcnt);
        GetExportData(paginationModel, data.data.totalCount, type);

      })
      .catch((error) => {
        console.log(error);
        setIsError(true);
      }).finally(() => {
        setIsError(false);
        setIsLoading(false);
        setIsRefetching(false);
      });
  }
  const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '400px',
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 6,
    pt: 2,
    px: 4,
    pb: 3,
    height: '100%',
    overflow: 'scroll'

  };



  const columns = useMemo(
    () => [
      // {
      //   accessorKey: 'recordNumber',
      //   header: '#',
      //   enableSorting: false,
      // },
      {
        accessorKey: 'data.name',
        id: 'name',
        header: 'نام',
      },
      {
        accessorKey: 'data.family',
        id: 'family',
        header: 'نام خانوادگی',
      },
      {
        accessorKey: 'data.ssn',
        id: 'ssn',
        header: 'کد ملی',
      },
      {
        accessorKey: 'data.fatherName',
        id: 'fatherName',
        header: 'نام پدر',
      },
      {
        accessorKey: 'data.brokerNo',
        id: 'brokerNo',
        header: 'شماره کاروان',
      },
    ],
    [],
  );


  const table = useMaterialReactTable({
    columns,
    data,
    enableFilters: false,
    enableRowSelection: false,
    getRowId: (row) => row.phoneNumber,
    initialState: { showColumnFilters: true },
    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    muiToolbarAlertBannerProps: isError
      ? {
        color: 'error',
        children: 'Error loading data',
      }
      : undefined,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    rowCount,
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      sorting,
    },

    muiTableHeadCellProps: {
      //simple styling with the `sx` prop, works just like a style prop in this example
      sx: {
        backgroundColor: 'rgb(113, 185, 172)',
        textAlign: 'right'
      },
    },
    muiTableBodyCellProps: ({ column }) => ({
      //conditionally style pinned columns
      sx: {
        textAlign: 'right',
      },
    }),
    muiTableBodyProps: {
      sx: {
        //stripe the rows, make odd rows a darker color
        '& tr:nth-of-type(odd) > td': {
          backgroundColor: '#f5f5f5',
        },
      },
    },
    enableRowActions: true,
    displayColumnDefOptions: {
      'mrt-row-actions': {
        header: ' ', //change header text
      },
    },
    positionActionsColumn: 'last',
    renderRowActions: ({ row }) => (
      <div dir="rtl">
        <Box >
          <Button color="secondary"
            onClick={() => {
              handleOpenPassengerModal(row.original.data)
            }}> جزئیات
          </Button>
          {AccessControl.checkPermissions(userPermissions, ["PassengerFinancialReport:Excel"]) &&

            <Button color="secondary"
              onClick={() => {
                handleOpenPassengerModalMali(row.original.data)
              }}> جزئیات مالی
            </Button>
          }
        </Box>

      </div>
    ),

  });
  const fetchGroupsByBrokerId = (id) => {
    passengerApi.GetGroupsByBrokerID(id).then((res) => {
      const arr = helper.DictionayToList(res.data.data);
      setGroupNoS(arr.map((o) => {
        return {
          id: o.value,
          label: o.value
        };
      }));
    })
      .catch((err) => {
        console.log(err);
      });
  }

  const handleBrokerChanged = useCallback(async (id) => {
    setGroupNoS([]);
    if (id) {
      const groups = await fetchGroupsByBrokerId(id);
      setGroupNoS(groups);
    }
  }, []);
  const saveExcel = async (expData, columns, workBookName) => {
    try {
      const fileName = workBookName;

      // creating one worksheet in workbook
      const worksheet = workbook.addWorksheet(workSheetName);
      worksheet.views = [{ rightToLeft: true }];
      // add worksheet columns
      // each columns contains header and its mapping key from data
      worksheet.columns = columns;

      // updated the font for first row.
      worksheet.getRow(1).font = { bold: true };

      // loop through all of the columns and set the alignment with width.
      worksheet.columns?.forEach(column => {
        if (column.name === '')
          column.width = column.header.length + 5;
        column.alignment = { horizontal: 'center' };
      });

      // loop through data and add each one to worksheet
      expData?.forEach(singleData => {
        worksheet.addRow(singleData);
      });

      // loop through all of the rows and set the outline style.
      worksheet.eachRow({ includeEmpty: false }, row => {
        // store each cell to currentCell
        const currentCell = row._cells;

        // loop through currentCell to apply border only for the non-empty cell of excel
        currentCell.forEach(singleCell => {
          // store the cell address i.e. A1, A2, A3, B1, B2, B3, ...
          const cellAddress = singleCell._address;
          singleCell.numFmt = '@'
          // apply border
          // worksheet.getCell(cellAddress).border = {
          //   top: { style: 'thin' },
          //   left: { style: 'thin' },
          //   bottom: { style: 'thin' },
          //   right: { style: 'thin' }
          // };
        });
      });

      // write the content using writeBuffer
      const buf = await workbook.xlsx.writeBuffer();

      // download the processed file
      saveAs(new Blob([buf]), `${fileName}.xlsx`);
    } catch (error) {
      console.error('<<<ERRROR>>>', error);
      console.error('Something Went Wrong', error.message);
    } finally {
      // removing worksheet's instance to create new one
      workbook.removeWorksheet(workSheetName);
    }
  };

  const handleChangeTags = (tags) => {
    setSSNList(tags)
  }
  return (
    <>
      <ThemeProvider theme={customtheme(customization)}>
        <RtlProvider>
          <Typography component="h1" variant="h5" mb={2} >
            لیست زائر      </Typography>
          <form onSubmit={handleSubmit(onSubmit)} >
            <Grid container spacing={1}>
              <Grid container spacing={1}>
                              <Grid item md={2} xs={10} >
                                <RHFAutocomplete
                                  control={control}
                                  options={opration}
                                  name="oprationId"
                                  placeholder="عملیات عمره"
                                  style={{
                                    border: "none",
                                    padding: 0
                                  }}
                                />
                              </Grid>
               
                <Grid item md={1}>
                  <RHFAutocomplete
                    control={control}
                    options={filterOperatorTxt}
                    name="passNoFO"
                    placeholder="نوع فیلتر شماره گذرنامه"
                    style={{
                      border: "none",
                      padding: 0
                    }}
                  />
                </Grid>
                <Grid item size={6}>
                  <TextField id="passNo" variant="outlined" {...register("passNo")} label="شماره گذرنامه" />
                </Grid>
                 <Grid item size={6}>
                  <TagsInput value={SSNList} onChange={handleChangeTags} inputProps={{placeholder: 'کد ملی'}} addOnBlur={true}/>
                </Grid>
                <Grid item md={1.5}>

                  <RHFAutocomplete
                    control={control}
                    options={passengerType}
                    name="passengerTypeID"
                    placeholder="نوع"
                    style={{
                      border: "none",
                      padding: 0
                    }}
                  />
                </Grid>

              </Grid>
              <Grid container spacing={1} sx={{ marginTop: 0.5, marginBottom: 0.5 }}>
                <Grid item md={1} >
                  <RHFAutocomplete
                    control={control}
                    options={filterOperatorTxt}
                    name="nameFO"
                    placeholder="نوع فیلتر نام"
                    style={{
                      border: "none",
                      padding: 0
                    }}
                  />
                </Grid>
                <Grid item size={6} >
                  <TextField id="name" variant="outlined" {...register("name")} fullWidth label="نام" />
                </Grid>
                <Grid item md={1} >
                  <RHFAutocomplete
                    control={control}
                    options={filterOperatorTxt}
                    name="familyFO"
                    placeholder="نوع فیلتر نام خانوادگی"
                    style={{
                      border: "none",
                      padding: 0
                    }}
                  />
                </Grid>
                <Grid item size={6} >
                  <TextField id="lastName" variant="outlined" {...register("lastName")} fullWidth label="نام خانوادگی" />
                </Grid>
                <Grid item md={1} >
                  <RHFAutocomplete
                    control={control}
                    options={filterOperatorTxt}
                    name="fatherNameFO"
                    placeholder="نوع فیلتر نام پدر"
                    style={{
                      border: "none",
                      padding: 0
                    }}
                  />
                </Grid>
                <Grid item size={6} >
                  <TextField id="fatherName" variant="outlined" {...register("fatherName")} fullWidth label="نام پدر" />
                </Grid>
                <Grid item md={1} >

                  <RHFAutocomplete
                    control={control}
                    options={sexType}
                    name="sexTypeID"
                    placeholder="جنسیت"
                    style={{
                      border: "none",
                      padding: 0
                    }}
                  />
                </Grid>
               
              </Grid>
              <Grid container spacing={1} sx={{ marginTop: 0.5, marginBottom: 0.5 }}>
 <Grid item md={1} >
                  <RHFAutocomplete
                    control={control}
                    options={filterOperatorType}
                    name="ageGroupFO"
                    placeholder="نوع فیلتر گروه سنی"
                    style={{
                      border: "none",
                      padding: 0
                    }}
                  />
                </Grid>
                <Grid item md={1.5}>

                  <RHFAutocomplete
                    control={control}
                    options={staticData.ageGroup}
                    name="ageGroupID"
                    placeholder="گروه سنی"
                    style={{
                      border: "none",
                      padding: 0
                    }}
                  />
                </Grid>
                <Grid item md={1.5} xs={7.5} >
                  <RHFAutocomplete
                    control={control}
                    options={brokerIDS}
                    name="brokerID"
                    placeholder="شماره کاروان"
                    onChange={handleBrokerChanged}
                    style={{
                      border: "none",
                      padding: 0
                    }}
                  />
                </Grid>
                <Grid item md={2.5} >
                  <RHFAutocomplete
                    control={control}
                    options={groupNoS}
                    name="groupNo"
                    placeholder="شماره گروه"
                    style={{
                      border: "none",
                      padding: 0
                    }}
                  />
                </Grid>
                <Grid item size={2}>
                  <TextField id="flightNO" variant="outlined" {...register("flightNO")} label="شماره پرواز" />
                </Grid>
                <Grid item size={1.5}>

                  <Controller
                    control={control}
                    name="flightDateFrom"
                    rules={{ required: true }}
                    render={({
                      field: { onChange, name, value },
                      fieldState: { invalid, isDirty },
                    }) => (
                      <>
                        <DatePicker
                          value={value || ""}
                          onChange={(date) => {
                            onChange(date?.isValid ? date : "");
                          }}
                          format={"YYYY/MM/DD"}
                          calendar={persian}
                          locale={persian_fa}
                          calendarPosition="bottom-right"
                          render={<CustomDateInput label={" از تاریخ پرواز"} />}
                        />
                      </>
                    )}
                  />
                </Grid>
                <Grid item size={1.5}>

                  <Controller
                    control={control}
                    name="flightDateTo"
                    rules={{ required: true }}
                    render={({
                      field: { onChange, name, value },
                      fieldState: { invalid, isDirty },
                    }) => (
                      <>
                        <DatePicker
                          value={value || ""}
                          onChange={(date) => {
                            onChange(date?.isValid ? date : "");
                          }}
                          format={"YYYY/MM/DD"}
                          calendar={persian}
                          locale={persian_fa}
                          calendarPosition="bottom-right"
                          render={<CustomDateInput label={"تا تاریخ پرواز"} />}
                        />
                      </>
                    )}
                  />
                </Grid>


              </Grid>
              <Grid item size={4} spacing={1} sx={{ marginTop: 0.5, marginBottom: 0.5 }}>
                <Button type="submit" variant="contained" color="primary"  >
                  جستجو
                </Button>
              </Grid>
            </Grid>
          </form>
        </RtlProvider>
        <div dir="rtl">
          <Box sx={{ textAlign: 'left', dir: 'rtl' }}>

            {AccessControl.checkPermissions(userPermissions, ["PassengerFinancialReport:Excel"]) &&
              <Tooltip title="دانلود اکسل مالی" placement="top">
                <IconButton disabled={loadingExport || isLoading} type="button" onClick={() => { handleExportClick(2) }}>
                  {(loadingExport || isLoading) && <CircularProgress color="inherit" size="20px" sx={{ mx: '0.5rem' }} />}
                  <ImFileExcel color='#BF3A06' />
                </IconButton>
              </Tooltip>}
            <Tooltip title="دانلود اکسل" placement="top">
              <IconButton disabled={loadingExport || isLoading} type="button" onClick={() => { handleExportClick(1) }}>
                {(loadingExport || isLoading) && <CircularProgress color="inherit" size="20px" sx={{ mx: '0.5rem' }} />}
                <ImFileExcel color='#04636E' />
              </IconButton>
            </Tooltip>

          </Box>
          <Typography ><Box sx={{ textAlign: 'left', dir: 'rtl' }}> {'تعداد نتایج' + ' : ' + rowCount} </Box></Typography>

          <Box sx={{ marginTop: 1 }} >
            <MaterialReactTable table={table} />
          </Box>
        </div>
        <Modal
          alignItems='center'
          open={openPassengerModal}
          onClose={handleClosePassengerModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={modalStyle}>
            <Typography id="modal-modal-description" >

              <PassengerInfo selectedPassenger={selectedPassenger} Ismali={false} />
              <Button typ onClick={handleClosePassengerModal}>بستن</Button>
            </Typography>
          </Box>
        </Modal>
        <Modal
          alignItems='center'
          open={openPassengerModalMali}
          onClose={handleClosePassengerModalMali}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={modalStyle}>
            <Typography id="modal-modal-description" >

              <PassengerInfo selectedPassenger={selectedPassenger} Ismali={true} />
              <Button typ onClick={handleClosePassengerModalMali}>بستن</Button>
            </Typography>
          </Box>
        </Modal>
      </ThemeProvider>
    </>
  )
}

export default SearchPassenger